var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection1Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 58,
    viewBox: "0 0 82 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 37.0007,
    width: 45,
    height: 45,
    rx: 20,
    fill: "#A21CAF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00002 51.3332V21.9998C1.00002 19.0543 3.38783 16.6665 6.33335 16.6665H49C51.9456 16.6665 54.3334 19.0543 54.3334 21.9998V51.3332C54.3334 54.2788 51.9456 56.6665 49 56.6665H6.33335C3.38783 56.6665 1.00002 54.2788 1.00002 51.3332Z",
    stroke: "#78350F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 4.6665L27.6667 13.9998L37 4.6665",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection1Svg3);
export default __webpack_public_path__ + "static/media/section1svg3.ec00d64234b0ef2d0d78459837c86a3b.svg";
export { ForwardRef as ReactComponent };